module.exports = __webpack_public_path__ + "img/attestation.8d3bebcc.png";